const faImageCircleMinus = {
  prefix: 'fal',
  iconName: 'image-circle-minus',
  icon: [
    640,
    512,
    [128167, 'tint'],
    'e004',
    'M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7s-10.7 .2-16 .7L480 96c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96l0 233.4 67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L422.6 208c-10.1 4.6-19.7 10.2-28.6 16.6l-4.3-4.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448l188.6 0c5.9 11.4 12.9 22.2 21.1 32L64 480c-35.3 0-64-28.7-64-64L0 96zM32 374.6L32 416c0 17.7 14.3 32 32 32l41.4 0 96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM96 144c0-17.1 9.1-33 24-41.6s33.1-8.6 48 0s24 24.4 24 41.6s-9.1 33-24 41.6s-33.1 8.6-48 0S96 161.1 96 144zm32 0c0 8.8 7.2 16 16 16s16-7.2 16-16s-7.2-16-16-16s-16 7.2-16 16zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z',
  ],
};
export default faImageCircleMinus;
